/** @jsxImportSource @emotion/react */

import { ReactNode } from "react";
import {
  css,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import BaseButton from "components/common/Button/Base";
import { PALETTE } from "styles/base/variables";

interface ConfirmDialogProps {
  isOpen: boolean;
  title?: string;
  // 보통 DialogContentText 한 줄 또는 여러 줄
  children: ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  cancelLabel?: string;
  confirmLabel?: string;
  // true면 취소/확인 버튼을 모두 비활성화한다 (제출 중일 때 등)
  disabled?: boolean;
}

// "정말 하시겠습니까?" 류의 취소/확인 2버튼 확인 팝업 공용 컴포넌트.
// 담당자 지정 확인, 카카오톡 재발송 확인처럼 페이지마다 반복되던
// 동일한 마크업/스타일을 여기로 모았다.
function ConfirmDialog({
  isOpen,
  title = "알림",
  children,
  onCancel,
  onConfirm,
  cancelLabel = "취소",
  confirmLabel = "확인",
  disabled = false,
}: ConfirmDialogProps) {
  return (
    <Dialog open={isOpen} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions
        css={css`
          margin: 0 12px;
          padding: 12px;
          border-top: 1px solid ${PALETTE.border};
        `}
      >
        <BaseButton
          variant="outlined"
          color={PALETTE.primary}
          disabled={disabled}
          onClick={onCancel}
          css={css`
            padding: 8px 16px;
          `}
        >
          {cancelLabel}
        </BaseButton>
        <BaseButton
          variant="contained"
          color={PALETTE.primary}
          disabled={disabled}
          onClick={onConfirm}
          css={css`
            padding: 8px 16px;
          `}
        >
          {confirmLabel}
        </BaseButton>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;
